import { GraphLinksManager } from "@features/builder/UpdateMetadata/GraphLinks/GraphLinksManager"
import { MetadataFormSectionCard } from "@features/builder/UpdateMetadata/MetadataFormSectionCard"
import { METADATA_FORM_SECTIONS } from "@features/builder/UpdateMetadata/helpers"

export const MetadataFormLinksSection = () => {
  return (
    <MetadataFormSectionCard id={METADATA_FORM_SECTIONS.links} title="Links">
      <GraphLinksManager />
    </MetadataFormSectionCard>
  )
}

export default MetadataFormLinksSection
